/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalOrganizationLinkDto } from "../models/AjaxResponseOfListOfOperationalOrganizationLinkDto";
import type { AjaxResponseOfOperationalOrganizationLinkDto } from "../models/AjaxResponseOfOperationalOrganizationLinkDto";
import type { CreateOrUpdateOperationalOrganizationLinkInput } from "../models/CreateOrUpdateOperationalOrganizationLinkInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalOrganizationLinksAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalOrganizationLinkDto Success
   * @throws ApiError
   */
  public getAll({
    organizationId,
  }: {
    organizationId: number;
  }): CancelablePromise<AjaxResponseOfListOfOperationalOrganizationLinkDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/links",
      path: {
        organizationId: organizationId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationLinkDto Success
   * @throws ApiError
   */
  public create({
    organizationId,
    requestBody,
  }: {
    organizationId: number;
    requestBody?: CreateOrUpdateOperationalOrganizationLinkInput;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationLinkDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/links",
      path: {
        organizationId: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    organizationId,
    linkId,
  }: {
    organizationId: number;
    linkId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/links/{linkId}",
      path: {
        organizationId: organizationId,
        linkId: linkId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationLinkDto Success
   * @throws ApiError
   */
  public update({
    organizationId,
    linkId,
    requestBody,
  }: {
    organizationId: number;
    linkId: number;
    requestBody?: CreateOrUpdateOperationalOrganizationLinkInput;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationLinkDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/links/{linkId}",
      path: {
        organizationId: organizationId,
        linkId: linkId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
